import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface TemplateCardProps {
  title: string;
  description: string;
  imageColor: string;
  onClick: () => void;
  delay?: number;
}
export function TemplateCard({
  title,
  description,
  imageColor,
  onClick,
  delay = 0
}: TemplateCardProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    delay,
    duration: 0.4
  }} data-id="element-49">
      <motion.div whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick} className="group cursor-pointer border border-[var(--border)] hover:border-[var(--accent-gold)]/50 transition-colors h-full flex flex-col rounded-2xl overflow-hidden bg-[var(--bg-card)] shadow-sm hover:shadow-md" data-id="element-50">
        {/* Preview Placeholder */}
        <div className={`h-40 w-full ${imageColor} relative overflow-hidden`} data-id="element-51">
          <div className="absolute inset-0 bg-black/5 group-hover:bg-transparent transition-colors" data-id="element-52" />

          {/* Overlay Button */}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 bg-[var(--template-overlay)] backdrop-blur-[2px]" data-id="element-53">
            <span className="bg-[var(--accent-gold)] text-[#1a1f36] px-4 py-2 rounded-full text-sm font-bold flex items-center transform translate-y-4 group-hover:translate-y-0 transition-transform shadow-lg" data-id="element-54">
              Use Template <ArrowRight size={14} className="ml-2" data-id="element-55" />
            </span>
          </div>
        </div>

        <div className="p-5 flex flex-col flex-grow" data-id="element-56">
          <h3 className="text-lg font-bold text-[var(--text-primary)] mb-2 group-hover:text-[var(--icon-accent-amber)] transition-colors" data-id="element-57">
            {title}
          </h3>
          <p className="text-sm text-[var(--text-secondary)] leading-relaxed" data-id="element-58">
            {description}
          </p>
        </div>
      </motion.div>
    </motion.div>;
}